import { CollapsibleSection } from "components/collapsibleSection";
import { Tag } from "components/tag";
import { DiscountType, IPromotionConditionDetail } from "interfaces";
import { chunk } from "lodash";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const useWindowWide = (size: number) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setWidth]);

  return width > size;
};
export const ViewPromotionCouponCode = ({
  conditionDetailData,
}: {
  conditionDetailData: IPromotionConditionDetail;
}) => {
  const shouldShowCouponsSection = () => {
    const discountTypesWithCouponsSection = [
      DiscountType.PERCENT,
      DiscountType.FIX_PRICE,
    ];
    return discountTypesWithCouponsSection.includes(
      conditionDetailData?.discount_type_display
    );
  };

  const chunkedCouponCodes =
    chunk(
      conditionDetailData?.coupon_codes ?? [],
      useWindowWide(640) ? 3 : 1
    ) ?? [];

  return shouldShowCouponsSection() ? (
    <CollapsibleSection label="Coupon Code" defaultOpen={true}>
      <div className="w-full box-container">
        <div>
          <div className="col-span-full bg-magnolia-600 px-4 py-3 rounded-t-lg text-sm font-medium">
            Total Coupon Code:{" "}
            {(conditionDetailData?.coupon_codes ?? []).length}
          </div>
          <div className="grid max-h-[280px] overflow-y-auto text-sm sm:grid-cols-6">
            {chunkedCouponCodes.map((codes, index: number) => (
              <div
                key={index}
                className={twMerge(
                  "col-span-full flex flex-col sm:flex-row p-4",
                  index < chunkedCouponCodes.length - 1
                    ? "border-b border-magnolia-600 "
                    : ""
                )}
              >
                {codes.map((code) => (
                  <div className="flex-1" key={code.id}>
                    <Link
                      to={`/promotion/coupon/${code.id}`}
                      target="_blank"
                      className="underline"
                    >
                      <Tag text={code.code} type={"blue"} />
                    </Link>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </CollapsibleSection>
  ) : (
    <></>
  );
};
